import { action, makeAutoObservable } from 'mobx';

import {
  State,
} from '~/store/types';
import { createUuid } from '~/utils/uuid';
import { AddUserNotificationProps, UserActionNotification } from './Notification.types';

class NotificationsStore {
  rootStore: State;
  userActionNotifications: UserActionNotification[] = [];

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      removeNotification: action.bound,
      addUserActionNotification: action.bound,
    });
    this.rootStore = rootStore;
  }

  addUserActionNotification(notification: AddUserNotificationProps) {
    this.userActionNotifications.push(
      Object.assign(notification, { id: createUuid() })
    );
  }

  removeNotification(notificationId) {
    this.userActionNotifications = this.userActionNotifications.filter(
      (n) => n.id !== notificationId
    );
  }
}

export default NotificationsStore;
